import React from 'react';

import { QuestionnaireV3 as Props } from './types';
import QuestionnaireData from './Data';

export default function QuestionnaireV3(props: Props) {
  if (!props.questionnaireAnswerId) return null;
  return <QuestionnaireData {...props} />;
}
